/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Export_PdfInputs */

const en_reports_export_pdf = /** @type {(inputs: Reports_Export_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF`)
};

const pt_br2_reports_export_pdf = /** @type {(inputs: Reports_Export_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF`)
};

/**
* | output |
* | --- |
* | "PDF" |
*
* @param {Reports_Export_PdfInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_export_pdf = /** @type {((inputs?: Reports_Export_PdfInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Export_PdfInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_export_pdf(inputs)
	return pt_br2_reports_export_pdf(inputs)
});